import BaseView from "./_BaseView";
import getBrowser from "../util/getBrowser";

export default class SAPView extends BaseView {
    init() {
        super.init();

        if ($('#sapForm').length > 0) {

        }
    }

    setEvents() {
        super.setEvents();

        $('#sapForm button.returning').on('click', function () {
            $('.new-or-returning').hide();
            $('.returning-login').show();
        });

        $('#sapForm button.new').on('click', function () {
            $('.new-or-returning').hide();
            $('.new-account').show();
        });

        $('.sap a.back').on('click', function () {
            $('.new-or-returning').show();
            $('.new-account').hide();
            $('.returning-login').hide();
            return false;
        });

        if ($('.browser-options').length > 0) {
            const browser = getBrowser();
            if (browser !== false) {
                $('.browser-link').hide();
                $(`.browser-link.${browser}`).show();
            } else {
                $('.browser-link').hide();
                $('.browser-link.none').show();
            }
        }
    }
}
